<div class="min-h-screen bg-[#1a1a1a]">
  <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <!-- Main content grid -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <!-- Daily Reporting Card -->
          <div class="bg-white rounded-lg p-4 sm:p-6
              shadow-[0_0px_60px_-15px_rgba(0,0,0,0.9)] 
              hover:shadow-[0_0px_70px_-15px_rgba(0,0,0,0.9)]
              transition-shadow duration-300
              ring-1 ring-white/20">
          <!-- <div class="flex justify-between items-center mb-6">
            <h2 class="text-xl font-semibold text-gray-800">Daily Reporting</h2> -->
            <div class="flex justify-between items-center mb-6">
              <h2 class="text-xl font-semibold text-gray-800">Daily Reporting</h2>
              <button 
                (click)="openSettingsModal()"
                class="text-gray-500 hover:text-gray-700 transition-colors"
                title="Settings">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  class="h-6 w-6" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor">
                  <path 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    stroke-width="2" 
                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    stroke-width="2" 
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </button>
           

          </div>
          
            <form [formGroup]="reportingForm" (ngSubmit)="onSubmit()" class="space-y-4">
                <!-- Report Date -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Report Date
                  </label>
                  <div class="relative">
                    <input
                      type="date"
                      formControlName="reportDate"
                      class="absolute w-full opacity-0 cursor-pointer"
                    >
                    <div 
                      class="w-full px-3 py-2 border border-gray-300 rounded-md bg-white cursor-pointer flex items-center"
                    >
                      <span class="text-gray-700">{{ formattedDate }}</span>
                      <svg 
                        class="w-5 h-5 ml-auto text-gray-400" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        <path 
                          stroke-linecap="round" 
                          stroke-linejoin="round" 
                          stroke-width="2" 
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                  </div>
                  <!-- Override Toggle -->
                  <div *ngIf="isEditMode && isPastDate" class="mb-4">
                    <div class="flex items-center justify-between p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                      <div class="flex items-center">
                        <div class="text-yellow-800">
                          <p class="font-medium">Override Mode</p>
                          <p class="text-sm">This is a past date. Enable override to edit the existing report.</p>
                        </div>
                      </div>
                      <button type="button"
                              (click)="toggleOverride()"
                              [class.bg-yellow-500]="isOverrideMode"
                              [class.bg-gray-300]="!isOverrideMode"
                              class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2">
                        <span class="sr-only">Enable override</span>
                        <span [class.translate-x-5]="isOverrideMode"
                              [class.translate-x-0]="!isOverrideMode"
                              class="pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out">
                          <span [class.opacity-0]="isOverrideMode"
                                [class.opacity-100]="!isOverrideMode"
                                class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity duration-200 ease-in-out"
                                aria-hidden="true">
                            <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                              <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </span>
                          <span [class.opacity-100]="isOverrideMode"
                                [class.opacity-0]="!isOverrideMode"
                                class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity duration-200 ease-in-out"
                                aria-hidden="true">
                            <svg class="h-3 w-3 text-yellow-600" fill="currentColor" viewBox="0 0 12 12">
                              <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                            </svg>
                          </span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
            
                <!-- Actual Closed -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Actual Closed
                  </label>
                  <div class="relative">
                    <span class="absolute left-3 top-2 text-gray-500">$</span>
                    <input
                      type="number"
                      formControlName="actualClosed"
                      class="w-full pl-7 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter amount in dollars"
                    >
                  </div>
                </div>
            
                <!-- Tomorrow's Close Goal -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Tomorrow's Close Goal
                  </label>
                  <div class="relative">
                    <span class="absolute left-3 top-2 text-gray-500">$</span>
                    <input
                      type="number"
                      formControlName="tomorrowCloseGoal"
                      class="w-full pl-7 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter amount in dollars"
                    >
                  </div>
                </div>
            
                <!-- Daily GP -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Daily GP
                  </label>
                  <div class="relative">
                    <input
                      type="number"
                      formControlName="dailyGP"
                      class="w-full pr-8 pl-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      min="0"
                      max="100"
                      step="0.1"
                      placeholder="Enter percentage (0-100)"
                    >
                    <span class="absolute right-3 top-2 text-gray-500">%</span>
                  </div>
                  <div class="text-sm text-gray-500 mt-1">Enter value between 0-100</div>
                </div>
            
                <!-- Submit Button -->
                <div class="space-y-2">
                  <div *ngIf="isEditMode" class="text-sm text-blue-600 font-medium">
                    Edit Mode: You are updating an existing report
                  </div>
                  <button 
                    type="submit" 
                    class="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    [disabled]="isSubmitDisabled()"
                    [class.opacity-50]="isSubmitDisabled()"
                    [class.cursor-not-allowed]="isSubmitDisabled()">
                    {{ isEditMode ? 'Update Report' : 'Submit Report' }}
                  </button>
                </div>
            
                <!-- Read-only Fields -->
                <div class="mt-6 space-y-4 bg-gray-50 p-4 rounded-md">
                  <!-- Today's Goal -->
                  <div>
                    <label class="block text-sm font-medium text-gray-600 mb-1">
                      Today's Goal
                    </label>
                    <div class="relative">
                      <span class="absolute left-3 top-2 text-gray-500">$</span>
                      <input
                        type="text"
                        [value]="todayGoal"
                        readonly
                        class="w-full pl-7 pr-3 py-2 bg-gray-100 border border-gray-300 rounded-md"
                      >
                    </div>
                  </div>
            
                  <!-- Today's Variance -->
                  <div>
                    <label class="block text-sm font-medium text-gray-600 mb-1">
                      Today's Variance
                    </label>
                    <div class="relative">
                      <span class="absolute left-3 top-2 text-gray-500">$</span>
                      <input
                        type="text"
                        [value]="todayVariance | number:'1.0-0'"
                        readonly
                        [class]="'w-full pl-7 pr-3 py-2 bg-gray-100 border border-gray-300 rounded-md ' + (todayVariance < 0 ? 'text-red-600' : 'text-green-600')"
                      >
                    </div>
                  </div>
            
                  <!-- Monthly Variance -->
                  <div>
                    <label class="block text-sm font-medium text-gray-600 mb-1">
                      Monthly Variance
                    </label>
                    <div class="relative">
                      <span class="absolute left-3 top-2 text-gray-500">$</span>
                      <input
                        type="text"
                        [value]="monthlyVariance | number:'1.0-0'"
                        readonly
                        [class]="'w-full pl-7 pr-3 py-2 bg-gray-100 border border-gray-300 rounded-md ' + (monthlyVariance < 0 ? 'text-red-600' : 'text-green-600')"
                      >
                    </div>
                  </div>
                </div>
              </form>
          </div>
      
          <!-- Closing Goal Progress Card -->
          <div class="hidden lg:block bg-black p-0 sm:p-0 rounded-lg border-yellow-500">
            <div class="flex justify-center items-center relative">
              <!-- Add vertical month toggle buttons -->
              <div class="absolute left-0 top-1/2 -translate-y-1/2 flex flex-col gap-2 ml-2 z-10">
                <button 
                  (click)="previousMonth()"
                  class="p-2 bg-gray-800 hover:bg-gray-700 text-white rounded-full shadow-lg transition-colors"
                  title="Previous Month">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <div class="px-3 py-2 bg-gray-800 text-white rounded-md text-sm font-medium">
                  {{ displayMonth }}
                </div>
                <button 
                  (click)="nextMonth()"
                  class="p-2 bg-gray-800 hover:bg-gray-700 text-white rounded-full shadow-lg transition-colors"
                  [disabled]="isCurrentMonth"
                  [class.opacity-50]="isCurrentMonth"
                  title="Next Month">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
              <div class="w-full h-[85vh] xl:h-[90vh]">
                <lib-monthly-closing-gauge
                  [selectedDate]="selectedGaugeDate"
                  (dataUpdated)="refreshMonthlyData()">
                </lib-monthly-closing-gauge>
              </div>
            </div>
          </div>
        </div>
      
        <!-- Monthly Report Section -->
        <div class="hidden lg:block mt-8 border-t pt-6">
          <h3 class="text-lg font-semibold text-gray-800 mb-4">Monthly Report Overview</h3>
          <div class="overflow-x-auto bg-white rounded-lg shadow-lg">
            <div class="p-4 sm:p-6">
              <lib-daily-report-table [selectedDate]="selectedGaugeDate"></lib-daily-report-table>
            </div>
          </div>
        </div>
  </div>
</div>

<lib-settings-modal-tw
  [isOpen]="isSettingsModalOpen"
  [monthlyBudget]="monthlyBudget"
  (save)="onSettingsSave($event)"
  (cancel)="onSettingsCancel()"
></lib-settings-modal-tw>



